export default [
  {
    path: '/main/send-commands',
    name: 'sendcommands',
    meta: {
      tag: 'send_commands',
      name: 'Enviar Comandos',
      breadcrumb: 'Enviar Comandos'
    },
    component: () => import(/* webpackChunkName: "send-command" */ '@/views/main/sendcommands/Index.vue')
  }
]